import gql from 'graphql-tag';

export const getExclusionList = gql`
	query getExclusionList($airingId: String, $gameId: String) {
		getExclusionList(airingId: $airingId, gameId: $gameId) {
			id
			airingId
			gameId
			periods {
				items {
					id
					playId
					title
					shortText
					startTime
					endTime
					endpoint
				}
			}
		}
	}
`;
